export default __webpack_public_path__ + "static/media/matthew.07236f31.jpeg";